import { useMemo } from "react";

import { useStoreContext } from "context";

import {
    getOpenSearchStoreReadiness,
    type OpenSearchStoreReadiness,
} from "../utils/get-opensearch-store-readiness";

type UseOpenSearchStoreReadinessResult = {
    isLoading: boolean;
    readiness: OpenSearchStoreReadiness | null;
    isReady: boolean;
};

function useOpenSearchStoreReadiness(
    storeId?: string | null,
): UseOpenSearchStoreReadinessResult {
    const {
        getTreezStoreContextByStoreId,
        treezSellConfigsLoading,
        treezSellConfigUnavailableReason,
    } = useStoreContext();

    const key = storeId?.trim() ?? "";

    const readiness = useMemo(() => {
        if (!key) {
            return null;
        }

        return getOpenSearchStoreReadiness({
            storeId: key,
            context: getTreezStoreContextByStoreId(key),
            configUnavailableReason: treezSellConfigUnavailableReason,
        });
    }, [key, getTreezStoreContextByStoreId, treezSellConfigUnavailableReason]);

    return {
        isLoading: treezSellConfigsLoading,
        readiness,
        isReady: readiness?.status === "ready",
    };
}

export { useOpenSearchStoreReadiness };
export type { UseOpenSearchStoreReadinessResult };
